import { styled } from "styled-components";

import { UIButton } from "common/components";
import { Link } from "common/components/Link";
import { breakpoints } from "common/styles";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { interpolate } from "domains/language/interpolate";

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.backgroundPrimary};
  color: ${({ theme }) => theme.colors.fillPrimary};
  justify-content: center;

  @media ${breakpoints.medium} {
    align-items: center;
  }
`;

const StyledInnerContainer = styled.div`
  max-width: 600px;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  padding: 3rem;
  border-radius: 10px;
  margin: 1rem;
`;

const StyledTitle = styled.h1`
  margin-top: 0;
`;

type FallbackProps = { error?: boolean };

export const Fallback = ({ error }: FallbackProps) => {
  const go = useGo();
  const translate = useTranslate();

  const supportEmail = (supportEmail: string) => <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>;

  const errorText = interpolate(translate("app.topic.follow.error_message"), { supportEmail });

  return (
    <StyledContainer>
      {error && (
        <StyledInnerContainer>
          <StyledTitle>{translate("app.error.unknown.title")}</StyledTitle>
          <p>{errorText}</p>
          <UIButton onClick={() => go("/")} variant="filled" fullwidth>
            {translate("app.auth.go_back")}
          </UIButton>
        </StyledInnerContainer>
      )}
    </StyledContainer>
  );
};
